module.exports = __webpack_public_path__ + "static/media/geschichte-corinna.03801809.jpg";